import { post } from "@/utils/utils";
// 导购相关接口
const reportCenter = {
  state: {
    spuRank: {},
    allSpuRank: {},
    brandRank: {},
    allBrandRank: {},
    memberRank: {},
    allMemberRank: {},
    pushMemberRank: {},
    allPushMemberRank: {},
    reportMemberList: {},
    reportCouponList: {},
    allAeportCouponList: {},
    reportGoodsList: {},
    customTableHeaderData: []
  },
  mutations: {
    QUERY_SPU_RANK(state, data) {
      state.spuRank = data.result;
    },
    QUERY_ALL_SPU_RANK(state, data) {
      state.allSpuRank = data.result;
    },
    QUERY_BRAND_RANK(state, data) {
      state.brandRank = data.result;
    },
    QUERY_ALL_BRAND_RANK(state, data) {
      state.allBrandRank = data.result;
    },
    QUERY_MEMBER_RANK(state, data) {
      state.memberRank = data.result;
    },
    QUERY_ALL_MEMBER_RANK(state, data) {
      state.allMemberRank = data.result;
    },
    QUERY_PUSHMEMBER_RANK(state, data) {
      state.pushMemberRank = data.result;
    },
    QUERY_ALL_PUSHMEMBER_RANK(state, data) {
      state.allPushMemberRank = data.result;
    },
    QUERY_REPORTMEMBER_LIST(state, data) {
      state.reportMemberList = data.result;
    },
    QUERY_REPORTCOUPON_LIST(state, data) {
      state.reportCouponList = data.result;
    },
    QUERY_ALL_REPORTCOUPON_LIST(state, data) {
      state.allAeportCouponList = data.result;
    },
    QUERY_REPORTGOODS_LIST(state, data) {
      state.reportGoodsList = data.result;
    },
    QUERY_ALL_REPORTGOODS_LIST(state, data) {
      state.allReportGoodsList = data.result;
    },
    QUERY_STORE_GOODS_INFO_LIST() {},
    QUERY_GOODS_ACTIVE_DETAIL() {},
    DAYS_ORDER_DETAILS_LIST() {},
    DAYS_ORDER_COUPON_LIST() {},
    EXPORT_ORDER_DETAILS() {},
    EXPORT_COUPON_DETAILS() {},
    SSR_QUERY_MODE() {},
    SSR_COLUMN_TYPE() {},
    ADD_SSR_BASIC_CONFIG() {},
    QUERY_SSR_BASIC_CONFIG_LIST() {},
    EDIT_SSR_BASIC_CONFIG() {},
    QUERY_HAS_AUTH() {},
    GET_ALL_STORE_CODES() {},
    GET_STORE_BY_NAME() {},
    SAVE_AUTH() {},
    CANCEL_AUTH() {},
    QUERY_AUTH_PAGE_LIST() {},
    QUERY_ANALYZE_LIST() {},
    QUERY_REPORT_SEARCH() {},
    QUERY_REPORT_TABLE_HEADER() {},
    SSR_IS_PUBLISHED() {},
    REPORT_ISSUE() {},
    QUERY_REPORT_TABLE_OPERATION() {},
    QUERY_USE_PAGE_LIST(state, data) {
      state.customTableHeaderData = data;
    },
    SAVE_AUTH_EMP() {},
    QUERY_ALL_AUTH_EMP() {},
    SAVE_HEADER() {},
    QUERY_HEADER() {},
    LOAD_TREE_ROOT() {},
    SYS_COLLECTION() {},
    SYS_COLLECTION_DEL() {},
    QUERY_SYS_COLLECTION() {},
    QUERY_FAVORITE_LIST() {},
    QUERY_RECENT_USAGE_LIST() {},
    SQL_PARSE_VERSION() {},
    ELASTICSEARCH_PARSE_VERSION() {},
    ELASTICSEARCH_DSL_VERSION() {},
    QUERY_USE_ANALTSIS_QUEUE() {},
    QUERY_USE_ANALTSIS_QUEUE_DETAILS() {},
    QUERY_HEMIAO_VISUAL_REPORT_HEADER() {},
    SAVE_HEMIAO_VISUAL_REPORT() {},
    QUERY_SAVED_HEMIAO_VISUAL_REPORT() {},
    REMOVE_STORE_VISUAL_REPORT_LIST() {},
    QUERY_STORE_VISUAL_REPORT_DETAILS() {},
    EDIT_STORE_VISUAL_REPORT_LIST() {},
    SAVE_STORE_VISUAL_REPORT_LIST() {},
    QUERY_STORE_VISUAL_REPORT_LIST() {},
    SET_DEFAULT_STORE_VISUAL_REPORT() {},
    QUERY_STORE_PAGE_LIST_EMP() {},
    GET_SYS_ALL_DICTITEMS() {},
    SYS_RECENT_USAGE() {},
    GET_TREE_STRUCT() {},
    QUERY_EMP_LIST_BY_ID() {},
    ADD_BY_EMPID() {},
    QUERY_SAVE_BY_EMP() {},
    QUERY_SSR_QUEUE_DATA() {},
    QUERY_SST_DATE_TYPE() {},
    EMP_CANCEL_AUTH() {},
    EMP_SAVE_AUTH() {},
    DEL_SST_CHEDU_RECORD() {},
    QUERY_CROSS_REPORT_LIST() {},
    QUERY_CROSS_REPORT_ALL_LIST() {},
    QUERY_OVERSEAS_GOODS_DETAIL() {},
    QUERY_SPECIAL_TABLE() {},
    QUERY_SPECIAL_TABLE_BY_TABLE_NAME() {},
    REPORTS_SSR_CONFIG_QUERY_ID() {},
    MD_COMPONENT_DATE_TYPE() {},
    QUERY_CALENDAR_RANGE() {},
    QUERY_SSR_TEMPLATE_REPORTE_DATA() {},
    QUERY_STORE_VISUAILZE() {},
    SAVE_STORE_VISUALIZE() {},
    QUERY_SSR_ANALYSIS_QUEUE_FILTER_DETAIL(){},
    QUERY_ORDER_DIVIDE_DETAILS() {},
    CACL_GJP_POS_ORDER_DIVIDE_JOB() {},
    QUERY_GJP_BRAND_LIST() {},
    QUERY_GJP_GUIDER_LIST() {},
    QUERY_GJP_SHOP_LIST() {},
    QUERY_GJP_CATEGORY_TREE() {},
    GET_GJP_POS_ORDER_DIVIDE_SUMMARY() {},
    GET_GJP_POS_GOODS_DIVIDE_SUMMARY() {},
    QUERY_GJP_ALL_PAY_TYPE_LIST() {},
    QUERY_GJP_USE_PAY_TYPE_LIST() {},
    EDIT_GJP_USE_PAY_TYPE() {},
    EXPORT_GJP_POS_ORDER_DIVIDE() {},
    QUERY_ORDER_DIVIDE_DETAILS_GOODS() {},
    GET_GJP_POS_GOODS_SUMMARY() {},
    EXPORT_GJP_POS_GOODS_DIVIDE() {},
    MD_ELASTICSEARCH_INDEX_PREFIX_INFO_QUERY_PAGE_LIST() {},
    MD_ELASTICSEARCH_CLUSTER_INFO_REFRESH_CLUSTER_INFO() {},
  },
  actions: {
    querySpuRank({ commit }, params) {
      return post({
        commit,
        url: `/basic/report/rank/spu`,
        name: "QUERY_SPU_RANK",
        params
      });
    },
    queryAllSpuRank({ commit }, params) {
      return post({
        commit,
        url: `/basic/report/rank/spu`,
        name: "QUERY_ALL_SPU_RANK",
        params
      });
    },
    queryBrandRank({ commit }, params) {
      return post({
        commit,
        url: `/basic/report/rank/brand`,
        name: "QUERY_BRAND_RANK",
        params
      });
    },
    queryAllBrandRank({ commit }, params) {
      return post({
        commit,
        url: `/basic/report/rank/brand`,
        name: "QUERY_ALL_BRAND_RANK",
        params
      });
    },
    queryMemberRank({ commit }, params) {
      return post({
        commit,
        url: `/basic/report/rank/member`,
        name: "QUERY_MEMBER_RANK",
        params
      });
    },
    queryAllMemberRank({ commit }, params) {
      return post({
        commit,
        url: `/basic/report/rank/member`,
        name: "QUERY_ALL_MEMBER_RANK",
        params
      });
    },
    queryPushMemberRank({ commit }, params) {
      return post({
        commit,
        url: `/basic/report/rank/push_member`,
        name: "QUERY_PUSHMEMBER_RANK",
        params
      });
    },
    queryAllPushMemberRank({ commit }, params) {
      return post({
        commit,
        url: `/basic/report/rank/push_member`,
        name: "QUERY_ALL_PUSHMEMBER_RANK",
        params
      });
    },
    queryReportMemberList({ commit }, params) {
      return post({
        commit,
        url: `/basic/report/member/list`,
        name: "QUERY_REPORTMEMBER_LIST",
        params
      });
    },
    queryReportCouponList({ commit }, params) {
      return post({
        commit,
        url: `/basic/report/coupon/list`,
        name: "QUERY_REPORTCOUPON_LIST",
        params
      });
    },
    queryAllReportCouponList({ commit }, params) {
      return post({
        commit,
        url: `/basic/report/coupon/list`,
        name: "QUERY_ALL_REPORTCOUPON_LIST",
        params
      });
    },
    queryReportGoodsList({ commit }, params) {
      return post({
        commit,
        url: `/basic/report/spu/list`,
        name: "QUERY_REPORTGOODS_LIST",
        params
      });
    },
    queryAllReportGoodsList({ commit }, params) {
      return post({
        commit,
        url: `/basic/report/spu/list`,
        name: "QUERY_ALL_REPORTGOODS_LIST",
        params
      });
    },
    queryStoreGoodsInfoList({ commit }, params) {
      return post({
        commit,
        url: `/basic/wxshopspu/queryStoreGoodsInfoList`,
        name: "QUERY_STORE_GOODS_INFO_LIST",
        params
      });
    },
    queryGoodsActiveDetail({ commit }, params) {
      return post({
        commit,
        url: `/basic/wxshopspu//queryGoodsActiveByWxshopSkuId`,
        name: "QUERY_GOODS_ACTIVE_DETAIL",
        params
      });
    },
    queryDaystatOrderDetailsList({ commit }, params) {
      return post({
        commit,
        url: `/reports/daystatOrderDetails/queryOnlineOrderPageList`,
        name: "DAYS_ORDER_DETAILS_LIST",
        params
      });
    },
    queryExportOrderDetails({ commit }, params) {
      return post({
        commit,
        url: `/reports/daystatOrderDetails/exportOnlineOrderDetails?false`,
        name: "EXPORT_ORDER_DETAILS",
        params
      });
    },
    queryExportCouponDetails({ commit }, params) {
      return post({
        commit,
        url: `/reports/daystatCouponDetails/exportCouponDetails?false`,
        name: "EXPORT_COUPON_DETAILS",
        params
      });
    },
    queryDaystatCouponDetailsList({ commit }, params) {
      return post({
        commit,
        url: `/reports/daystatCouponDetails/queryPageList`,
        name: "DAYS_ORDER_COUPON_LIST",
        params
      });
    },
    queryReportMode({ commit }, params) {
      return post({
        commit,
        url: `/sys/common/dict_items?dictCode=ssr_query_mode`,
        name: "SSR_QUERY_MODE",
        params
      });
    },
    queryReportColumn({ commit }, params) {
      return post({
        commit,
        url: `/sys/common/dict_items?dictCode=ssr_column_type`,
        name: "SSR_COLUMN_TYPE",
        params
      });
    },
    addSsrBasicConfig({ commit }, params) {
      return post({
        commit,
        url: `/reports/ssrBasicConfig/add`,
        name: "ADD_SSR_BASIC_CONFIG",
        params
      });
    },
    querySsrBasicConfigList({ commit }, params) {
      return post({
        commit,
        url: `/reports/ssrBasicConfig/queryPageList`,
        name: "QUERY_SSR_BASIC_CONFIG_LIST",
        params
      });
    },
    editSsrBasicConfig({ commit }, params) {
      return post({
        commit,
        url: `/reports/ssrBasicConfig/edit`,
        name: "EDIT_SSR_BASIC_CONFIG",
        params
      });
    },
    queryHasAuth({ commit }, params) {
      return post({
        commit,
        url: `/reports/ssrStoreAuthRel/queryPageList`,
        name: "QUERY_HAS_AUTH",
        params
      });
    },
    getAllStoreCodes({ commit }, params) {
      return post({
        commit,
        url: `/storeBasicInfo/getAllStoreCodes`,
        name: "GET_ALL_STORE_CODES",
        params
      });
    },
    getStoreByName({ commit }, params) {
      return post({
        commit,
        url: `/storeBasicInfo/getStoreByName`,
        name: "GET_STORE_BY_NAME",
        params
      });
    },
    saveAuth({ commit }, params) {
      return post({
        commit,
        url: `/reports/ssrStoreAuthRel/saveAuth`,
        name: "SAVE_AUTH",
        params
      });
    },
    cancelAuth({ commit }, params) {
      return post({
        commit,
        url: `/reports/ssrStoreAuthRel/cancelAuth`,
        name: "CANCEL_AUTH",
        params
      });
    },
    cancelEmpAuth({ commit }, params) {
      return post({
        commit,
        url: `reports/ssrEmployeeAuthRel/cancelAuth`,
        name: "EMP_CANCEL_AUTH",
        params
      });
    },
    cancelSaveAuth({ commit }, params) {
      return post({
        commit,
        url: `reports/ssrEmployeeAuthRel/saveAuth`,
        name: "EMP_SAVE_AUTH",
        params
      });
    },
    queryAuthPageList({ commit }, params) {
      return post({
        commit,
        url: `/store/ssrBasicConfig/queryAuthPageList`,
        name: "QUERY_AUTH_PAGE_LIST",
        params
      });
    },
    queryAnalyzeList({ commit }, params) {
      return post({
        commit,
        url: `/store/ssrBasicConfig/addSsrAnalysisQueue`,
        name: "QUERY_ANALYZE_LIST",
        params
      });
    },
    queryReportSearch({ commit }, params) {
      return post({
        commit,
        url: `/sys/common/getUiPopoverByPopoverCode?popoverCode=reports_search_tip`,
        name: "QUERY_REPORT_SEARCH",
        params
      });
    },
    queryReportTableHeader({ commit }, params) {
      return post({
        commit,
        url: `/sys/common/getUiPopoverByPopoverCode?popoverCode=reports_table_header_tip`,
        name: "QUERY_REPORT_TABLE_HEADER",
        params
      });
    },
    queryIsPublished({ commit }, params) {
      return post({
        commit,
        url: `/sys/common/dict_items?dictCode=ssr_is_published`,
        name: "SSR_IS_PUBLISHED",
        params
      });
    },
    reportIssue({ commit }, params) {
      return post({
        commit,
        url: `/reports/ssrBasicConfig/publishSsr`,
        name: "REPORT_ISSUE",
        params
      });
    },
    queryReportTableOperation({ commit }, params) {
      return post({
        commit,
        url: `/sys/common/getUiPopoverByPopoverCode?popoverCode=report_table_operation`,
        name: "QUERY_REPORT_TABLE_OPERATION",
        params
      });
    },
    queryUsePageList({ commit }, params) {
      return post({
        commit,
        url: `/store/ssrBasicConfig/queryUsePageList`,
        name: "QUERY_USE_PAGE_LIST",
        params
      });
    },
    saveAuthEmp({ commit }, params) {
      return post({
        commit,
        url: `/reports/ssrEmployeeAuthRel/refreshAuth`,
        name: "SAVE_AUTH_EMP",
        params
      });
    },
    queryAllAuthEmp({ commit }, params) {
      return post({
        commit,
        url: `/reports/ssrEmployeeAuthRel/queryPageList`,
        name: "QUERY_ALL_AUTH_EMP",
        params
      });
    },
    saveHeader({ commit }, params) {
      return post({
        commit,
        url: `/reports/ssrLayoutRecord/saveEmployeeLayout`,
        name: "SAVE_HEADER",
        params
      });
    },
    queryHeader({ commit }, params) {
      return post({
        commit,
        url: `/reports/ssrLayoutRecord/queryEmployeePageList`,
        name: "QUERY_HEADER",
        params
      });
    },
    // 过滤
    querySsrAnalysisQueueFilterDetail({ commit }, params) {
      return post({
        commit,
        url: `/store/ssrBasicConfig/querySsrAnalysisQueueFilterDetail`,
        name: "QUERY_SSR_ANALYSIS_QUEUE_FILTER_DETAIL",
        params
      });
    },
    queryHeMiaoVisualReportHeader({ commit }, params) {
      return post({
        commit,
        url: `/reports/ssrBasicConfig/queryPageList`,
        name: "QUERY_HEMIAO_VISUAL_REPORT_HEADER",
        params
      });
    },
    saveStoreVisualReportList({ commit }, params) {
      return post({
        commit,
        url: `/reports/storeLayoutComponentsTemplate/addStoreLayoutComponentsTemplate`,
        name: "SAVE_STORE_VISUAL_REPORT_LIST",
        params
      });
    },
    editStoreVisualReport({ commit }, params) {
      return post({
        commit,
        url: `/reports/storeLayoutComponentsTemplate/edit`,
        name: "EDIT_STORE_VISUAL_REPORT_LIST",
        params
      });
    },
    removeStoreVisualReportList({ commit }, params) {
      return post({
        commit,
        url: `/reports/storeLayoutComponentsTemplate/delete`,
        name: "REMOVE_STORE_VISUAL_REPORT_LIST",
        params
      });
    },
    queryStoreVisualReportList({ commit }, params) {
      return post({
        commit,
        url: `/reports/storeLayoutComponentsTemplate/queryStorePageList`,
        name: "QUERY_STORE_VISUAL_REPORT_LIST",
        params
      });
    },
    setDefaultStoreVisualReport({ commit }, params) {
      return post({
        commit,
        url: `/reports/storeLayoutComponentsTemplate/setMasterLayout`,
        name: "SET_DEFAULT_STORE_VISUAL_REPORT",
        params
      });
    },
    queryStoreVisualReportDetails({ commit }, params) {
      return post({
        commit,
        url: `/reports/storeLayoutComponentsTemplate/queryById`,
        name: "QUERY_STORE_VISUAL_REPORT_DETAILS",
        params
      });
    },
    querySavedHeMiaoVisualReport({ commit }, params) {
      return post({
        commit,
        url: `/reports/ssrLayoutRecord/queryReportVisualize`,
        name: "QUERY_SAVED_HEMIAO_VISUAL_REPORT",
        params
      });
    },
    saveHeMiaoVisualReport({ commit }, params) {
      return post({
        commit,
        url: `/reports/ssrLayoutRecord/saveReportVisualize`,
        name: "SAVE_HEMIAO_VISUAL_REPORT",
        params
      });
    },
    loadTreeRoot({ commit }, params) {
      return post({
        commit,
        url: `/sys/category/loadTreeRootSplit`,
        name: "LOAD_TREE_ROOT",
        params
      });
    },
    sysCollection({ commit }, params) {
      return post({
        commit,
        url: `/system/sysPersonalizedFavorite/add`,
        name: "SYS_COLLECTION",
        params
      });
    },
    sysCollectionDel({ commit }, params) {
      return post({
        commit,
        url: `/system/sysPersonalizedFavorite/delete`,
        name: "SYS_COLLECTION_DEL",
        params
      });
    },
    querySysCollectionDel({ commit }, params) {
      return post({
        commit,
        url: `/system/sysPersonalizedFavorite/getOne`,
        name: "QUERY_SYS_COLLECTION",
        params
      });
    },
    queryFavoriteList({ commit }, params) {
      return post({
        commit,
        url: `/store/ssrBasicConfig/queryFavoriteList`,
        name: "QUERY_FAVORITE_LIST",
        params
      });
    },
    queryRecentUsageList({ commit }, params) {
      return post({
        commit,
        url: `/store/ssrBasicConfig/queryRecentUsageList`,
        name: "QUERY_RECENT_USAGE_LIST",
        params
      });
    },
    sqlParseVersion({ commit }, params) {
      return post({
        commit,
        url: `/sys/common/dict_items?dictCode=sql_parse_version`,
        name: "SQL_PARSE_VERSION",
        params
      });
    },
    elasticsearchParseVersion({ commit }, params) {
      return post({
        commit,
        url: `/sys/common/dict_items?dictCode=elasticsearch_parse_version`,
        name: "ELASTICSEARCH_PARSE_VERSION",
        params
      });
    },
    elasticsearchDslVersion({ commit }, params) {
      return post({
        commit,
        url: `/sys/common/dict_items?dictCode=elasticsearch_dsl_version`,
        name: "ELASTICSEARCH_DSL_VERSION",
        params
      });
    },
    queryNotUseSsrAnalysisQueue({ commit }, params) {
      return post({
        commit,
        url: `/store/ssrBasicConfig/queryNotUseSsrAnalysisQueue`,
        name: "QUERY_USE_ANALTSIS_QUEUE",
        params
      });
    },
    querySsrAnalysisQueueDetail({ commit }, params) {
      return post({
        commit,
        url: `/store/ssrBasicConfig/querySsrAnalysisQueueDetail?false`,
        name: "QUERY_USE_ANALTSIS_QUEUE_DETAILS",
        params
      });
    },
    queryStorePageListByEmployeeId({ commit }, params) {
      return post({
        commit,
        url: `/reports/storeLayoutComponentsTemplate/queryStorePageListByEmployeeId`,
        name: "QUERY_STORE_PAGE_LIST_EMP",
        params
      });
    },
    getSysAllDictItems({ commit }, params) {
      return post({
        commit,
        url: `/sys/permission/getSysAllDictItemsByEmployeeId`,
        name: "GET_SYS_ALL_DICTITEMS",
        params
      });
    },
    sysPersonalizedRecentUsageRecord({ commit }, params) {
      return post({
        commit,
        url: `/system/sysPersonalizedRecentUsageRecord/add?false`,
        name: "SYS_RECENT_USAGE",
        params
      });
    },
    getTreeStruct({ commit }, params) {
      return post({
        commit,
        url: `/sys/common/getCategoryTreeStruct?pcode=B03`,
        name: "GET_TREE_STRUCT",
        params
      });
    },
    queryEmployeePageListByEmployeeId({ commit }, params) {
      return post({
        commit,
        url: `/reports/ssrLayoutRecord/queryEmployeePageListByEmployeeId`,
        name: "QUERY_EMP_LIST_BY_ID",
        params
      });
    },
    addByEmployeeId({ commit }, params) {
      return post({
        commit,
        url: `/system/sysPersonalizedFavorite/saveOrUpdateByEmployeeId`,
        name: "ADD_BY_EMPID",
        params
      });
    },
    querySaveByEmployeeId({ commit }, params) {
      return post({
        commit,
        url: `/system/sysPersonalizedFavorite/queryPageListByEmployeeId`,
        name: "QUERY_SAVE_BY_EMP",
        params
      });
    },
    addSsrAnalysisQueueByEmployeeId({ commit }, params) {
      return post({
        commit,
        url: `/store/ssrBasicConfig/addSsrAnalysisQueueByEmployeeId`,
        name: "QUERY_SSR_QUEUE_DATA",
        params
      });
    },
    querySsrDateType({ commit }, params) {
      return post({
        commit,
        url: `/sys/common/dict_items?dictCode=ssr_date_range_type`,
        name: "QUERY_SST_DATE_TYPE",
        params
      });
    },
    delSysSchedulingRecord({ commit }, params) {
      return post({
        commit,
        url: `/system/sysSchedulingRecord/delete`,
        name: "DEL_SST_CHEDU_RECORD",
        params
      });
    },
    queryCrossCategoryList({ commit }, params) {
      return post({
        commit,
        url: `/basic/report/category/queryCategoryList`,
        name: "QUERY_CROSS_REPORT_LIST",
        params
      });
    },
    queryCrossCategoryAllList({ commit }, params) {
      return post({
        commit,
        url: `/basic/report/category/queryCategoryList`,
        name: "QUERY_CROSS_REPORT_ALL_LIST",
        params
      });
    },
    getOverseasGoodsDetail({ commit }, params) {
      return post({
        commit,
        url: `/mobile_mall/getOverseasGoodsDetail`,
        name: "QUERY_OVERSEAS_GOODS_DETAIL",
        params
      });
    },
    querySpecialTable({ commit }, params) {
      return post({
        commit,
        url: `/metadata/mdTablesInfo/querySpecialTable`,
        name: "QUERY_SPECIAL_TABLE",
        params
      });
    },
    queryPageListByTableName({ commit }, params) {
      return post({
        commit,
        url: `/metadata/mdColumnsInfo/queryPageListByTableName`,
        name: "QUERY_SPECIAL_TABLE_BY_TABLE_NAME",
        params
      });
    },
    ssrBasicConfigQueryById({ commit }, params) {
      return post({
        commit,
        url: `/reports/ssrBasicConfig/queryById`,
        name: "REPORTS_SSR_CONFIG_QUERY_ID",
        params
      });
    },
    queryComponentDataType({ commit }, params) {
      return post({
        commit,
        url: `/sys/common/dict_items?dictCode=md_component_date_type`,
        name: "MD_COMPONENT_DATE_TYPE",
        params
      });
    },
    queryCalendarRange({ commit }, params) {
      return post({
        commit,
        url: `/system/sysCalendar/queryCalendarRange`,
        name: "QUERY_CALENDAR_RANGE",
        params
      });
    },
    querySsrTemplatRpteData({ commit }, params) {
      return post({
        commit,
        url: `/store/ssrBasicConfig/querySsrTemplatRpteData`,
        name: "QUERY_SSR_TEMPLATE_REPORTE_DATA",
        params
      });
    },
    queryStoreVisualize({ commit }, params) {
      return post({
        commit,
        url: `/reports/ssrLayoutRecord/queryStoreVisualize`,
        name: "QUERY_STORE_VISUAILZE",
        params
      });
    },
    saveStoreVisualize({ commit }, params) {
      return post({
        commit,
        url: `/reports/ssrLayoutRecord/saveStoreVisualize`,
        name: "SAVE_STORE_VISUALIZE",
        params
      });
    },
    queryOrderDivideDetails({ commit }, params) {
      return post({
        commit,
        url: `/provider/scm/reports/check/getGjpPosOrderCheckDetails?pageNo=` + params.pageNo + "&pageSize=" + params.pageSize,
        name: "QUERY_ORDER_DIVIDE_DETAILS",
        params
      });
    },
    caclGjpPosOrderDivideJob({ commit }, params) {
      return post({
        commit,
        url: `/provider/scm/jobs/caclSingleGjpPosOrderDivideJob`,
        name: "CACL_GJP_POS_ORDER_DIVIDE_JOB",
        params
      });
    },
    queryGjpBrandList({ commit }, params) {
      return post({
        commit,
        url: `/provider/scm/reports/queryCondition/allBrand?storeCode=` + params.storeCode,
        name: "QUERY_GJP_BRAND_LIST",
        params
      });
    },
    queryGjpGuiderList({ commit }, params) {
      return post({
        commit,
        url: `/provider/scm/reports/queryCondition/allGuider?storeCode=` + params.storeCode,
        name: "QUERY_GJP_GUIDER_LIST",
        params
      });
    },
    queryGjpShopList({ commit }, params) {
      return post({
        commit,
        url: `/provider/scm/reports/queryCondition/allShop?storeCode=` + params.storeCode,
        name: "QUERY_GJP_SHOP_LIST",
        params
      });
    },
    queryGjpCategoryTree({ commit }, params) {
      return post({
        commit,
        url: `/provider/scm/reports/queryCondition/categoryTreeSonByParentCategoryId?storeCode=` + params.storeCode + '&parentCategoryId=' + params.parentCategoryId,
        name: "QUERY_GJP_CATEGORY_TREE",
        params
      });
    },
    getGjpPosOrderDivideSummary({ commit }, params) {
      return post({
        commit,
        url: `/provider/scm/reports/check/getGjpPosOrderCheckSummary`,
        name: "GET_GJP_POS_ORDER_DIVIDE_SUMMARY",
        params
      });
    },
    getGjpPosGoodsDivideSummary({ commit }, params) {
      return post({
        commit,
        url: `/provider/scm/reports/check/getGjpPosOrderGoodsCheckSummary`,
        name: "GET_GJP_POS_GOODS_DIVIDE_SUMMARY",
        params
      });
    },
    queryGjpAllPayTypeList({ commit }, params) {
      return post({
        commit,
        url: `/provider/scm/reports/queryCondition/allPaytypeid?storeCode=` + params.storeCode,
        name: "QUERY_GJP_ALL_PAY_TYPE_LIST",
        params
      });
    },
    queryGjpUsePayTypeList({ commit }, params) {
      return post({
        commit,
        url: `/provider/scm/reports/config/usedPaytypeid?storeCode=` + params.storeCode,
        name: "QUERY_GJP_USE_PAY_TYPE_LIST",
        params
      });
    },
    editGjpUsePayType({ commit }, params) {
      return post({
        commit,
        url: `/provider/scm/reports/config/modifyPaytypeid?storeCode=` + params.storeCode + "&paytypeids=" + params.paytypeids,
        name: "EDIT_GJP_USE_PAY_TYPE",
        params
      });
    },
    exportGjpPosOrderDivide({ commit }, params) {
      return post({
        commit,
        url: `/provider/scm/reports/check/exportGjpPosOrderCheckCsv`,
        name: "EXPORT_GJP_POS_ORDER_DIVIDE",
        params
      });
    },
    queryOrderDivideDetailsGoods({ commit }, params) {
      return post({
        commit,
        url: `/provider/scm/reports/goods/getGjpPosOrderGoodsDetails?pageNo=` + params.pageNo + "&pageSize=" + params.pageSize,
        name: "QUERY_ORDER_DIVIDE_DETAILS_GOODS",
        params
      });
    },
    getGjpPosGoodsSummary({ commit }, params) {
      return post({
        commit,
        url: `/provider/scm/reports/goods/getGjpPosOrderGoodsSummary`,
        name: "GET_GJP_POS_GOODS_SUMMARY",
        params
      });
    },
    exportGjpPosGoodsDivide({ commit }, params) {
      return post({
        commit,
        url: `/provider/scm/reports/goods/exportGjpPosOrderGoodsCsv`,
        name: "EXPORT_GJP_POS_GOODS_DIVIDE",
        params
      });
    },
    mdElasticsearchIndexPrefixInfoQueryPageList({ commit }, params) {
      return post({
        commit,
        url: `/metadata/mdElasticsearchIndexPrefixInfo/queryPageList`,
        name: "MD_ELASTICSEARCH_INDEX_PREFIX_INFO_QUERY_PAGE_LIST",
        params
      });
    },
    mdElasticsearchClusterInfoRefreshClusterInfo({ commit }, params) {
      return post({
        commit,
        url: `/metadata/mdElasticsearchClusterInfo/refreshClusterInfo`,
        name: "MD_ELASTICSEARCH_CLUSTER_INFO_REFRESH_CLUSTER_INFO",
        params
      });
    },
}
};

export default reportCenter;
